import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTabItem} from '@Hooks/poster-editor/useGetKeyFromTabItem';

export function NumberOfTabsOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemNumTabs = useGetKeyFromTabItem('numTabs');

  if (!activeItem) {
    throw new Error('Active Item is null');
  }

  if (!activeItem.isTab() || itemNumTabs === undefined) {
    throw new Error(`Expected tab item, instead got ${activeItem.gitype}`);
  }

  const updateNumberOfTabs = (numTabs: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        numTabs,
      },
      {
        undoable,
      }
    );
  };

  const onChangeHandler = (updatedValue: number): void => {
    updateNumberOfTabs(updatedValue, false);
  };

  const onChangeEndedHandler = (updatedValue: number): void => {
    updateNumberOfTabs(updatedValue);
  };

  return (
    <ContextualMenuSliderOptions
      id="number-tabs-option"
      value={itemNumTabs}
      label={window.i18next.t('pmwjs_no_of_tabs')}
      range={{
        min: 2,
        max: 20,
      }}
      transformDisplay={{
        min: 2,
        max: 20,
      }}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEndedHandler}
    />
  );
}
